<template>
  <div>
    <div class="contentSelect">
      <el-select
        v-model="contentSelect"
        placeholder="请选择需要修改的内容类型"
        @change="_getContentType"
      >
        <el-option
          v-for="item in contentType"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="content">
      <!--左侧菜单-->
      <div v-if="Object.keys(treeData).length > 0" class="tree">
        <div class="custom-tree-container">
          <div class="block">
            <p>菜单栏</p>
            <el-tree
              highlight-current="true"
              :data="treeData"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false"
              :render-content="renderContent"
              @node-click="handlerNodeClick"
            >
            </el-tree>
          </div>
        </div>
      </div>

      <!--右侧表单-->
      <div v-if="Object.keys(form).length > 0" class="form">
        <form-tpl
          :form="form"
          class="form"
          :fatherFrom="fatherForm"
          @refreshInsert="refreshInsert"
          @refresh="refresh"
        />
      </div>
    </div>
  </div>
</template>

<script>
import formTpl from '@/components/Form/form-tpl'
import { myMixin } from '../../mixin'
import HomeApi from '../../network/home'
import { program_type } from '../../common/enum/imgEnum'
import toTree from '../../utils/generateTree'
export default {
  name: 'EditTree',
  components: {
    formTpl
  },
  mixins: [myMixin],
  data() {
    return {
      contentSelect: '',
      contentType: [
        { value: 7, label: '关于我们' },
        { value: 8, label: '服务范围' }
      ],
      treeData: [],
      form: {},
      addFromId: '',
      fatherForm: {}
    }
  },
  methods: {
    // 获取展示内容
    async _getContent() {
      const result = await HomeApi.getContent(
        program_type.official_website,
        this.contentSelect
      )
      const re = JSON.parse(JSON.stringify(result.data))
      re.forEach((key) => {
        key.label = key.title
      })
      const narr = this.arrGetName(re)
      const arr = toTree(narr)
      this.treeData = arr
    },

    refresh(type) {
      this.contentSelect = type
      this._getContentType()
    },

    refreshInsert(type) {
      this.form = {}
      this.contentSelect = type
      this._getContentType()
    },

    // 获取select选项
    _getContentType() {
      this._getContent()
    },

    append(data) {
      data.isParent = '1'
      data.isUpdate = true
      this.fatherForm = data
      const newChild = {
        title: '',
        label: '暂时标题',
        fatherId: data.id,
        contentType: data.contentType,
        programType: data.programType,
        children: [],
        isInsert: true
      }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
      this.form = {}
      this.form = newChild
    },

    remove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex((d) => d.id === data.id)
      children.splice(index, 1)
    },

    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              style="padding-left: 20px"
              on-click={() => this.append(data)}
            >
              添加
            </el-button>
          </span>
        </span>
      )
    },

    // 节点点击事件
    handlerNodeClick(node) {
      this.form = {}
      this.form = node
    }
  }
}
</script>

<style scoped>
.tree {
  max-width: 400px;
  margin-top: 50px;
}

.content {
  display: flex;
}

.form {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
